<script>
import HeroHeader from '@/components/HeroHeader.vue'
import {
  fetchSponsor,
  setStoredSponsor,
  clearStoredSponsor,
  isReservedUsername,
} from '@/utils/sponsor'

export default {
  components: { HeroHeader },

  mounted() {
    this.resolveSponsor()
  },

  methods: {
    async resolveSponsor() {
      const username = String(this.$route.params.username || '').trim()

      if (!username || isReservedUsername(username)) {
        this.$router.replace({ name: 'wizard' })
        return
      }

      try {
        const data = await fetchSponsor(username)

        if (data.status === 'success' && data.user) {
          setStoredSponsor(data.user)
        } else {
          clearStoredSponsor()
        }
      } catch {
        clearStoredSponsor()
      }

      this.$router.replace({ name: 'wizard' })
    },
  },
}
</script>

<template>
  <div class="page">
    <HeroHeader />
    <main class="container-narrow wizard-shell">
      <div class="sponsor-capture">
        <div class="sponsor-capture__spinner" aria-hidden="true" />
        <p class="sponsor-capture__text">Carregando...</p>
      </div>
    </main>
  </div>
</template>

<style scoped>
.sponsor-capture {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
  text-align: center;
}

.sponsor-capture__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: #fff;
  border-radius: 50%;
  animation: sponsor-spin 0.8s linear infinite;
}

.sponsor-capture__text {
  margin-top: 1rem;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.95rem;
}

@keyframes sponsor-spin {
  to { transform: rotate(360deg); }
}
</style>
